import { Logger, Cached, DeviceConsoleLogger, Flavor, ServiceAuthType } from '@uploadcam/common';
import * as Sentry from '@sentry/angular';
import { AUTH_PROCESS_URL } from '../../app/app-routing.module';
import { environment } from '../../environments/environment';
import { GoogleApiService } from './google/google-api.service';
import { SentryLogger } from '../../@harmony/sentry';
import { TriggerFunctionInteractor } from './domain/interactors/trigger-function.interactor';
import { Functions } from 'firebase/functions';
import { GoogleIdentityService } from './google/google-identity.service';

export abstract class CommonProvider {
  abstract provideFunctions(): Functions;
  abstract provideGoogleApiService(): GoogleApiService;
  abstract provideGoogleIdentityService(): GoogleIdentityService;
  abstract provideLogger(): Logger;
  abstract provideOAuthRedirectUri(authType: ServiceAuthType): string;
  abstract provideStorage(): Storage;
  abstract provideTriggerFunction(): TriggerFunctionInteractor;
}

export class CommonDefaultProvider implements CommonProvider {
  constructor(
    private readonly flavor: Flavor,
    private readonly functions: Functions,
    private readonly googleApiKey: string,
    private readonly sentry: typeof Sentry,
    private readonly sentryDsn: string | undefined,
  ) {}

  @Cached()
  public provideGoogleApiService(): GoogleApiService {
    return new GoogleApiService(
      this.googleApiKey,
      ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
      this.flavor,
    );
  }

  @Cached()
  public provideGoogleIdentityService(): GoogleIdentityService {
    return new GoogleIdentityService();
  }

  @Cached()
  public provideLogger(): Logger {
    if (this.sentryDsn) {
      return new SentryLogger(this.sentry);
    } else {
      return new DeviceConsoleLogger(window.console);
    }
  }

  public provideFunctions(): Functions {
    return this.functions;
  }

  public provideOAuthRedirectUri(authType: ServiceAuthType): string {
    const baseUrl = environment.baseUrl.replace(/\/*$/, '');
    const processUrl = AUTH_PROCESS_URL.replace(':authType', authType).replace(/^\/*/, '');

    return `${baseUrl}/${processUrl}`;
  }

  public provideStorage(): Storage {
    return window.localStorage;
  }

  @Cached()
  public provideTriggerFunction(): TriggerFunctionInteractor {
    return new TriggerFunctionInteractor(this.functions);
  }
}
